var wasDragging_bool = false;
var scrollEventAdded_bool = false;
var scrollSensitivity_num = 1;
var currentScrollable_object;
var oldMousePos, newMousePos, oldMouseTime, newMouseTime, startMouseTime, startMousePos;
var minDragTime = 100; //miliseconds
var minDragSpace = 10;
// SCROLL INIT
function makeScrollable(obj, mask, bottomMargine, scrollBarColor) {
    obj.scrollable = true;

    makeInteractive(mask, "pointerdown", onScrollPointerDown);
    makeInteractive(mask, "pointerup", onScrollPointerUp);
    makeInteractive(mask, "pointerupoutside", onScrollPointerUpOutside);
    makeInteractive(mask, "pointermove", onScrollPointerMove);
    makeInteractive(mask, "pointerover", onScrollPointerOver);
    makeInteractive(mask, "pointerout", onScrollPointerOut);

    if (bottomMargine == undefined) {
        bottomMargine = 0;
    }
    scrollBarColor = scrollBarColor || 0x000000;

    obj.minY = obj.y;
    obj.maxY = obj.y - obj.height + mask.height - bottomMargine;
    //add scroll bar
    var barX = mask.x - mask.anchor.x * mask.width + mask.width - 10;
    var barY = mask.y - mask.anchor.y * mask.height;

    obj.scrollBar = new Rectangle(mask.parent, [6, mask.height * mask.height / obj.height]);
    obj.scrollBar.position.set(barX, barY);
    obj.scrollBar.anchor.set(0);
    obj.scrollBar.tint = scrollBarColor;
    obj.scrollBar.maxY = barY + mask.height - obj.scrollBar.height;
    obj.scrollBar.minY = barY;
    obj.mask = mask;
    obj.scrollBar.mask = mask;
    mask.masked = obj;
    if (!scrollEventAdded_bool) {
        scrollEventAdded_bool = true;
        APP.view.addEventListener('mousewheel', onScrollMouseWheel);
    }
    enableScroll(obj, mask, true);
}

// ENABLE SCROLL
function enableScroll(obj, mask, boolVal) {
    mask.interactive = boolVal;
    mask.buttonMode = boolVal;
    for (var i = 0; i < obj.children.length; i++) {
        if (obj.getChildAt(i).onPointerUp != undefined) {
            obj.getChildAt(i).interactive = boolVal;
        }
    }

    if (obj.scrollBar != undefined) {
        obj.scrollBar.visible = boolVal;
    }

    if (!boolVal) {
        currentScrollable_object = null;
    }
}

function updateScroll(obj, mask, bottomMargine) {
    if (obj.scrollAnim)
        obj.scrollAnim.kill();

    if (obj.textAnim)
        obj.textAnim.kill();

    obj.y = obj.minY;
    if (obj.height < mask.height)
    {
        enableScroll(obj, mask, false);
        return;
    }
    else
    {
        enableScroll(obj, mask, true);
    }
        

    bottomMargine = bottomMargine || 0;
    obj.maxY = obj.y - obj.height + mask.height - bottomMargine;
    //add
    var barX = mask.x - mask.anchor.x * mask.width + mask.width - 10;
    var barY = mask.y - mask.anchor.y * mask.height;

    var scrollBarColor = obj.scrollBar.tint;
    var scrollBarAlpha = obj.scrollBar.alpha;
    obj.scrollBar.delete();
    obj.scrollBar = new Rectangle(mask.parent, [6, mask.height * mask.height / obj.height]);
    obj.scrollBar.position.set(barX, barY);
    obj.scrollBar.anchor.set(0);
    obj.scrollBar.tint = scrollBarColor;
    obj.scrollBar.alpha = scrollBarAlpha;
    obj.scrollBar.maxY = barY + mask.height - obj.scrollBar.height;
    obj.scrollBar.minY = barY;
    obj.scrollBar.mask = mask;

}

// ON POINTER UP
function onScrollPointerUp(e) {
    var obj = this.masked;

    obj.isScrolling = false;
    newMouseTime = new Date().getTime();
    newMousePos = e.data.getLocalPosition(this.parent);

    if (oldMousePos != undefined) {
        var duration = 0.75;
        var scrollSpeed = (newMousePos.y - oldMousePos.y) * scrollSensitivity_num * 3 / (newMouseTime - oldMouseTime);
        var textTargetY = obj.y + scrollSpeed * duration / 0.016;
        textTargetY = Math.min(Math.max(textTargetY, obj.maxY), obj.minY);
        var moveFactor = (textTargetY - obj.minY) / (obj.maxY - obj.minY);
        var scrollTargetY = obj.scrollBar.minY + (obj.scrollBar.maxY - obj.scrollBar.minY) * moveFactor;

        keepMoving(obj, duration, textTargetY, scrollTargetY);

        fixScroll(obj);
    }

    if (!wasDragging_bool) {
        var gl_pos = e.data.getLocalPosition(APP.stage);
        var child = (PIXI.interaction.InteractionManager.prototype.hitTest(gl_pos, obj));
        if (child != undefined) {
            if ((e.type == "tap") && (child.onTouchEnd)) {
                child.onTouchEnd(e);
            }
            if ((e.type != "tap") && (child.onMouseUp)) {
                child.onMouseUp(e);
            }

            if (child.onPointerUp) {
                child.onPointerUp(e);
            }

        }
    }
}

// ON POINTER DOWN
function onScrollPointerDown(e) {
    wasDragging_bool = false;
    var obj = this.masked;
    obj.isScrolling = true;
    newMousePos = e.data.getLocalPosition(this.parent);
    startMousePos = {
        x: newMousePos.x,
        y: newMousePos.y
    };
    newMouseTime = new Date().getTime();
    startMouseTime = newMouseTime;
    if (obj.textAnim != undefined) {
        obj.textAnim.kill();
        obj.scrollAnim.kill();
    }

    if (!wasDragging_bool) {
        var gl_pos = e.data.getLocalPosition(APP.stage);
        var child = (PIXI.interaction.InteractionManager.prototype.hitTest(gl_pos, obj));
        if (child != undefined) {
            if (child.onPointerDown) {
                child.onPointerDown(e);
            }

        }
    }

}

// ON POINTER UP OUTSIDE
function onScrollPointerUpOutside(e) {
    var obj = this.masked;

    obj.isScrolling = false;
    newMouseTime = new Date().getTime();
    newMousePos = e.data.getLocalPosition(this.parent);
    if (oldMousePos != undefined) {
        var duration = 0.75;

        var scrollSpeed = (newMousePos.y - oldMousePos.y) * scrollSensitivity_num * 3 / (newMouseTime - oldMouseTime);
        var textTargetY = obj.y + scrollSpeed * duration / 0.016;
        textTargetY = Math.min(Math.max(textTargetY, obj.maxY), obj.minY);
        var moveFactor = (textTargetY - obj.minY) / (obj.maxY - obj.minY);
        var scrollTargetY = obj.scrollBar.minY + (obj.scrollBar.maxY - obj.scrollBar.minY) * moveFactor;

        keepMoving(obj, duration, textTargetY, scrollTargetY);

        fixScroll(obj);
    }
}

// ON SCROLL
function onScrollPointerMove(e) {
    var obj = this.masked;
    if (obj.isScrolling) {

        oldMousePos = newMousePos;
        newMousePos = e.data.getLocalPosition(this.parent);
        oldMouseTime = newMouseTime;
        newMouseTime = new Date().getTime();
        if ((newMouseTime - startMouseTime > minDragTime) && (Math.abs(oldMousePos.y - startMousePos.y) > minDragSpace)) {
            wasDragging_bool = true;
        }
        var sensitivity = scrollSensitivity_num;
        if (((obj.y < obj.maxY) && (newMousePos.y - oldMousePos.y < 0)) ||
            ((obj.y > obj.minY) && (newMousePos.y - oldMousePos.y > 0))) {
            sensitivity /= 10;
        }

        obj.y += (newMousePos.y - oldMousePos.y) * sensitivity;
        var moveFactor = (obj.y - obj.minY) / (obj.maxY - obj.minY);
        obj.scrollBar.y = obj.scrollBar.minY + (obj.scrollBar.maxY - obj.scrollBar.minY) * moveFactor;
    }


    var gl_pos = e.data.getLocalPosition(APP.stage);
    var child = (PIXI.interaction.InteractionManager.prototype.hitTest(gl_pos, obj));
    var chLen = obj.children.length;
    for (var i = 0; i < chLen; i++) {
        if ((obj.children[i].onMouseOut) && (child != obj.children[i])) {
            obj.children[i].onMouseOut(e);
        }
    }
    if (child != undefined) {

        if ((child.onMouseOver) && (!obj.isScrolling)) {
            child.onMouseOver(e);
        }

        //            if ((child.onPointerDown) && (obj.isScrolling)) {
        //                //child.onPointerDown(e);
        //            }
    }

}

// ON SCROLL WHEEL
function onScrollMouseWheel(e) {

    if (currentScrollable_object != undefined) {

        obj = currentScrollable_object;
        var duration = 0.2;
        var scrollSpeed = e.wheelDelta * scrollSensitivity_num * 0.03;
        var textTargetY = obj.y + scrollSpeed * duration / 0.016;
        textTargetY = Math.min(Math.max(textTargetY, obj.maxY), obj.minY);
        var moveFactor = (textTargetY - obj.minY) / (obj.maxY - obj.minY);
        var scrollTargetY = obj.scrollBar.minY + (obj.scrollBar.maxY - obj.scrollBar.minY) * moveFactor;

        if (obj.textAnim != undefined) {
            obj.textAnim.kill();
            obj.scrollAnim.kill();
        }
        keepMoving(obj, duration, textTargetY, scrollTargetY);
    }
}

// SET SCROLL OBJECT
function onScrollPointerOver(e) {
    this.pointerIsOver = true;
    currentScrollable_object = this.masked;
}

// REMOVE SCROLL OBJECT
function onScrollPointerOut(e) {
    this.pointerIsOver = false;
    currentScrollable_object = undefined;
}

// INERTION
function keepMoving(obj, duration, textTargetY, scrollTargetY) {
    obj.textAnim = TweenMax.to(obj, duration, {
        pixi: {
            y: textTargetY
        },
        ease: Power2.easeOut
    });
    obj.scrollAnim = TweenMax.to(obj.scrollBar, duration, {
        pixi: {
            y: scrollTargetY
        },
        ease: Power2.easeOut
    });
}

// DRAG BOUNCE
function fixScroll(obj) {

    if (obj.y > obj.minY) {
        obj.textAnim = TweenMax.to(obj, 0.4, {
            pixi: {
                y: obj.minY

            },
            ease: Elastic.easeOut.config(1, 0.3)
        });
        obj.scrollAnim = TweenMax.to(obj.scrollBar, 0.4, {
            pixi: {
                y: obj.scrollBar.minY
            },
            ease: Elastic.easeOut.config(1, 0.3)
        });
        return;
    }

    if (obj.y < obj.maxY) {
        obj.textAnim = TweenMax.to(obj, 0.4, {
            pixi: {
                y: obj.maxY
            },
            ease: Elastic.easeOut.config(1, 0.3)
        });

        obj.scrollAnim = TweenMax.to(obj.scrollBar, 0.4, {
            pixi: {
                y: obj.scrollBar.maxY
            },
            ease: Elastic.easeOut.config(1, 0.3)
        });
        return;
    }
}
